import { useState } from "react";
import { useTranslation } from "react-i18next";
import TeambookTextForm from "../../default_components/TeambookTextForm";
import DangerPic from "../../default_images/danger_deletion.svg";
import TeambookDialog from "../TeambookDialog";
import PropTypes from "prop-types";

const DeleteEntityDialog = ({ open, deleteEntity, entityToDelete, setOpen, teams }) => {
  const { t } = useTranslation();

  const [name, setName] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorField, setErrorField] = useState(null);
  const DeleteTeam = (team, name) => {
    if (team.name === name && teams.length !== 1) {
      closeErrorMessage();
      deleteEntity();
      closeDialog();
      closeConfirmDialog();
    } else {
      if (teams.length === 1) {
        setErrorMessage("You can't remove last team.");
        setErrorField("name");
      } else {
        setErrorMessage(t("planning.delete_team_error"));
        setErrorField("name");
      }
    }
  };

  const closeErrorMessage = () => {
    setErrorMessage(null);
    setErrorField(null);
  };

  const closeDialog = () => {
    setName("");
    closeErrorMessage();
    setOpen(false);
  };

  const closeConfirmDialog = () => {
    closeErrorMessage();
  };

  if (!entityToDelete) {
    return <div />;
  }

  return (
    <TeambookDialog
      onClose={closeDialog}
      open={open}
      htmlTitle={
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "20px"}}>
          <img style={{width: 50, height: 50}} src={DangerPic} onClick={closeDialog}/>
          <p style={{textAlign: "center"}}>
            {t("planning.delete_team_1")}
            <span style={{color: "#4c54a0"}}>{entityToDelete.name}</span>?
          </p>
        </div>
      }
      content={
        <>
          <p style={{fontSize: 18}}>{t("planning.delete_team_2")}</p>

          <p>
            {t("planning.delete_team_4")}
            <span style={{color: "#4c54a0"}}>{entityToDelete.name}</span>.
          </p>

          <TeambookTextForm
            fieldName={t("planning.team_name")}
            fieldValue={name}
            type={"text"}
            width="280px"
            onChange={setName}
            errorField={errorField}
            errorMessage={errorMessage}
            closeErrorMessage={closeErrorMessage}
            field={"name"}
          />
        </>
      }
      actionButtons={[
        {
          text: t("planning.delete_team_3"),
          onClick: () => {
            DeleteTeam(entityToDelete, name);
          },
          type: "red",
        },
        {
          text: t("cancel"),
          onClick: closeDialog,
          type: "outlined",
        }
      ]}
    />
  );
};

DeleteEntityDialog.propTypes = {
  open: PropTypes.bool,
  deleteEntity: PropTypes.func,
  entityToDelete: PropTypes.object,
  setOpen: PropTypes.func,
  teams: PropTypes.array,
};

export default DeleteEntityDialog;
